<template>
  <ml-input v-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <div v-else-if="multiple">
    <multiselect :options="disasterList" :value="data" @input="multipleInput" @select="multipleSelect" :multiple="true" placeholder="" openDirection="below" />
    <ml-input v-if="isCustomData" v-model="customData" class="mt-2 w-full" placeholder="직접입력" />
  </div>
  <div v-else>
    <vs-select v-model="singleDisasterData" autocomplete :disabled="disabled || readonly" class="w-full red-text disaster">
      <vs-select-item v-for="disaster in disasterList" :key="disaster" :value="disaster" :text="disaster" />
    </vs-select>
    <ml-input v-if="isCustomData" v-model="customDisasterData" class="mt-2 w-full" placeholder="직접입력" />
  </div>
</template>

<script>
/* eslint-disable brace-style */
import { disasters, disasters_안전_정기위험성평가, disasters_보건_정기위험성평가 } from "@/util/DisasterDataUtil.js";
import Multiselect from "vue-multiselect";
export default {
  name: "DisasterClassSelector",
  components: {
    Multiselect,
  },
  props: {
    /**
     * @param {String|Array} value - 선택된 재해형태 (String: 단일선택, Array: 다중선택)
     */
    value: {
      type: [String, Array],
      default: "",
    },
    listKey: {
      type: 'normal' | 'safety' | 'health',
      default: 'normal',
    }, // disasters | disasters_안전_정기위험성평가 | disasters_보건_정기위험성평가
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
  },
  computed: {
    isCustomData() {
      if (this.multiple) {
        if (this.useCustomData) {
          return true;
        }
        for (const item of this.data) {
          if (this.disasterList.indexOf(item) === -1 || item.indexOf("직접입력") >= 0) {
            return true;
          }
        }
      } else {
        return this.data && this.data.indexOf("직접입력") >= 0;
      }
    },
    singleDisasterData: {
      get() {
        if (this.data.indexOf("직접입력") >= 0) {
          return "직접입력";
        } else {
          return this.data;
        }
      },
      set(value) {
        this.data = value;
      },
    },
    customDisasterData: {
      get() {
        if (this.data.indexOf("직접입력") >= 0) {
          // _ 기호로 분할해서, [1] 번째 아이템을 반환한다
          return this.data.split("_")[1];
        } else {
          return "";
        }
      },
      set(value) {
        this.data = `직접입력_${value}`;
      }
    }
  },
  data() {
    return {
      disasterList: disasters,

      // 실제로 사용되는 데이터,
      // '직접입력' 을 선택할 경우, input 에 입력한 값이 저장된다.
      data: this.value,

      // '직접입력' 을 선택할 경우, input 에 입력한 값이 저장된다.
      useCustomData: false,
      customData: '',
      tempData: [], // 다중선택일 경우, 선택된 항목을 임시로 저장하는 변수
    };
  },
  watch: {
    /**
     * 이 컴포넌트의 v-model 값이 업데이트 됐을 때 실행되는 함수
     * @param value
     */
    value(value) {
      if (this.multiple) {
        const list = [];
        if (value && value.length > 0) {
          for (const data of value) {
            if (this.disasterList.indexOf(data) === -1) {
              list.push(`직접입력_${data}`);
            } else {
              list.push(data);
            }
          }
        }

        this.tempData = list;
        if (JSON.stringify(this.data) !== JSON.stringify(value)) {
          this.$set(this, "data", value);
        }
        return;
      }

      // 단일 선택일 경우
      // 만약 저장된 데이터가 disasters에 없다면, 직접입력된 항목이다.
      if (this.disasterList.indexOf(value) === -1) {
        // 만약 "직접입력_" 텍스트가 포함되어 있다면, 그대로 저장한다.
        if (value.indexOf("직접입력_") >= 0) {
          this.$set(this, "data", value);
        }
        // 그렇지 않다면, "직접입력_" 텍스트를 추가해서 저장한다.
        else {
          this.$set(this, "data", `직접입력_${value}`);
        }
      }
      // disasters에 있는 항목이라면, 그대로 저장한다.
      else {
        this.$set(this, "data", value);
      }

    },
    customData() {
      let index = -1;
      for (let i = 0; i < this.data.length; i++) {
        const item = this.data[i];
        if (this.disasterList.indexOf(item) === -1 || item.indexOf("직접입력") >= 0) {
          index = i;
          break;
        }
      }
      if (index >= 0) {
        this.$set(this.data, index, this.customData);
      } else if (this.customData) {
        this.data.push(this.customData);
      }
    },
    data(value) {
      this.emitInput();
    },
  },
  created() {
    if (this.listKey === "safety") {
      this.disasterList = disasters_안전_정기위험성평가;
    } else if (this.listKey === "health") {
      this.disasterList = disasters_보건_정기위험성평가;
    }
  },
  mounted() {},
  methods: {
    emitInput() {
      if (this.multiple) {
        const list = [];
        if (this.data && this.data.length > 0) {
          for (const data of this.data) {
            if (data === "직접입력") {
              list.push(this.customData);
            } else {
              list.push(data);
            }
          }
        }

        this.$emit("input", list);
      } else {
        // if (this.data === "직접입력") {
        //   this.$emit("input", this.customData);
        // } else {
        //   this.$emit("input", this.data);
        // }
        this.$emit("input", this.data);
      }
    },

    // 다중 선택일 경우, '직접입력' 항목을 선택했을 때
    multipleInput(data) {
      if (data.length < this.data.length) {
        // 삭제된 항목의 Index 를 찾는다.
        const removed = this.data.filter((item) => data.indexOf(item) === -1);
        const removedIndex = this.data.indexOf(removed[0]);
        const checkData = this.tempData[removedIndex];

        // 삭제된 항목을 data 에서 제거한다.
        this.data = data;

        // 삭제된 항목이 '직접입력' 항목이라면, customData 를 초기화한다.
        if (checkData.indexOf("직접입력") >= 0) {
          this.customData = '';
          this.useCustomData = false;
        }
      }
    },
    multipleSelect (data) {
      if (data.indexOf('직접입력') >= 0) {
        this.useCustomData = true;
      } else {
        this.data.push(data)
      }
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.red-text.disaster input {
  color: red;
}
</style>
<style lang="scss">
.multiselect {
  .multiselect__tags {
    .multiselect__tag {
      background-color: rgba(var(--vs-secondary), 1) !important;
    }
    .multiselect__tag-icon::after {
      color: rgb(30, 13, 97);
    }
    border-color: #cdcdcd !important;
  }
}
</style>
